import React from 'react';
import { motion } from 'framer-motion';
import { User ,Code2, Home, Layers, Contact, Info } from 'lucide-react';

const Header = ({ setActiveSection, activeSection }) => {
  const menuItems = [
    { name: 'home', label: 'Home', icon: Home },
    { name: 'services', label: 'Services', icon: Layers },
    { name: 'about', label: 'About', icon: Info },
    { name: 'contact', label: 'Contact', icon: Contact },
    { name: 'PrivacyPolicy', label: 'PrivacyPolicy', icon: Info },

  ];

  return (
    <header className="fixed top-0 left-0 w-full z-50 bg-gray-900/70 backdrop-blur-md ">
      <div className="container mx-auto flex justify-between items-center py-4 px-4">
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-500 to-cyan-500 animate-pulse"
        >
          Beta Pixel Studio
        </motion.div>

        <nav className="flex space-x-4">
          {menuItems.map((item) => (
            <motion.button
              key={item.name}
              onClick={() => setActiveSection(item.name)}
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
              className={`flex items-center space-x-2 px-3 py-2 rounded-lg transition-all duration-300 ${
                activeSection === item.name
                  ? 'bg-cyan-500/30 text-cyan-300'
                  : 'hover:bg-purple-500/20 text-gray-300'
              } relative overflow-hidden`}
            >
              <item.icon size={18} />
              <span className="hidden md:inline">{item.label}</span>
              {activeSection === item.name && (
                <motion.div
                  layoutId="activeSection"
                  className="absolute bottom-0 left-0 right-0 h-1 bg-cyan-500"
                />
              )}
            </motion.button>
          ))}
        </nav>
      </div>
    </header>
  );
};

export default Header;
